import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-loading-overlay-modal',
  templateUrl: './loading-overlay-modal.component.html',
  styleUrls: ['./loading-overlay-modal.component.scss']
})
export class LoadingOverlayModalComponent {
  @Input() public progress?: number;
  @Input() public status?: String = 'Please, wait!';
  @Input() public showProgress: boolean = false;
  @Input() public showStatus: boolean = false;
}
